export function getBenefit(
  originPrice: number | string,
  filterPrice: number | string
): number {
  return Number(originPrice) - Number(filterPrice);
}
